import { Clock, ClipboardList, FileText, ShieldCheck } from "lucide-react";

// Reusable, explicit discovery call agenda card.
const DiscoveryCallAgenda = ({ compact = false }: { compact?: boolean }) => (
  <div className={`rounded-2xl border border-border bg-card ${compact ? "p-5" : "p-6 md:p-8"}`}>
    <div className="flex items-center gap-2">
      <span className="inline-flex items-center gap-1.5 rounded-full border border-secondary/40 bg-secondary/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-foreground">
        <Clock className="h-3 w-3 text-secondary" /> 30 minutes · free · no obligation
      </span>
    </div>
    <h3 className="mt-4 font-display text-xl font-bold text-foreground">What we cover on the call</h3>
    <div className="mt-4 grid gap-4 md:grid-cols-2">
      <div className="flex gap-3">
        <ClipboardList className="mt-0.5 h-5 w-5 shrink-0 text-secondary" />
        <div>
          <div className="text-sm font-semibold text-foreground">We review together</div>
          <ul className="mt-1 space-y-1 text-sm text-muted-foreground">
            <li>· Your market, buy box, and lead sources</li>
            <li>· Your current dialer, CRM, and KPIs</li>
            <li>· Where your pipeline is leaking deals</li>
          </ul>
        </div>
      </div>
      <div className="flex gap-3">
        <FileText className="mt-0.5 h-5 w-5 shrink-0 text-secondary" />
        <div>
          <div className="text-sm font-semibold text-foreground">You walk away with</div>
          <ul className="mt-1 space-y-1 text-sm text-muted-foreground">
            <li>· A written pipeline & team-build plan</li>
            <li>· Honest starting pricing tied to your volume</li>
            <li>· Emailed within 48 hours, yours to keep</li>
          </ul>
        </div>
      </div>
    </div>
    <div className="mt-5 flex items-center gap-2 rounded-lg border border-border bg-muted/40 px-4 py-3">
      <ShieldCheck className="h-4 w-4 shrink-0 text-secondary" />
      <p className="text-xs text-muted-foreground">
        No pitch deck, no contract pressure. If we're not the right fit we'll tell you on the call
        and still send the plan.
      </p>
    </div>
  </div>
);

export default DiscoveryCallAgenda;
